import { gql } from 'urql'

export const fetchKapProgramYearlyFinancialReportMilestonesByProgramIdQuery = gql`
  query fetchKapProgramModulesAndBudgetByProgramId($kapProgramId: Int!, $milestoneFinancialReportType: String!) {
    kap_program_by_pk(id: $kapProgramId) {
      modules
      kap_program_budgets {
        budget_canton
        budget_gfch
        module
      }
      dossier {
        milestones(
          where: { _and: { type: { _eq: $milestoneFinancialReportType } } }
          order_by: [{ due_date: asc }, { year_in_focus: asc }, { type: asc }]
        ) {
          kap_program_financial_reports(
            where: { _or: [{ gfch_actual_value: { _is_null: false } }, { canton_actual_value: { _is_null: false } }] }
          ) {
            module
            milestone {
              year_in_focus
            }
            gfch_actual_value
            canton_actual_value
          }
          year_in_focus
        }
      }
    }
  }
`
